// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const supportsHover = (windowWidth?: number) => {
  if (typeof window === 'undefined') return false;
  return window.matchMedia('(hover: hover)').matches;
};
